import React, {useEffect, useState} from "react";
import {Form, Modal} from "react-bootstrap";
import {useFormik} from "formik";
import {defaultOrg} from "../../generic/InitialStates";
import {AGCText} from "../../../generic-components/AGCText";
import {AGCTextArea} from "../../../generic-components/AGCTextArea";
import {apiGenericCreate, apiGenericUpdate, genericGetOne} from "../../generic/crud";
import {ENTITY_ID_ORGANIZATIONS} from "../../generic/Constants";
import {showToast, TOAST_SUCCESS} from "../../../utils/toast/Toast";
import {AGCPassword} from "../../../generic-components/AGCPassword";

export function SAOrgsAddEditDialog(props) {
    const {show, handleClose, id, onSave} = props;
    const [objectForSubmit, setObjectForSubmit] = useState(defaultOrg);
    const [isLoading, setIsLoading] = useState(false);
    const [forUpdate, setForUpdate] = useState(false);
    const [title, setTitle] = useState("Organization");

    const entityName = "Organization";

    const formik = useFormik({
        initialValues: objectForSubmit,
        enableReinitialize: true,
        validate: (values) => {
            const errors = {};
            if (!forUpdate && values.adminPassword && values.adminPassword !== values.adminPasswordConfirm) {
                errors.adminPasswordConfirm = "Passwords do not match";
            }
            return errors;
        },
        onSubmit(organization, {resetForm}) {
            setIsLoading(true);
            // Remove adminPasswordConfirm before sending to backend
            const {adminPasswordConfirm, ...organizationData} = organization;

            if (!id) {
                apiGenericCreate(ENTITY_ID_ORGANIZATIONS, organizationData).then(() => {
                    setIsLoading(false);
                    handleClose();
                    showToast(entityName + " is Created!", TOAST_SUCCESS);
                    resetForm();
                    if (onSave) onSave();
                }).catch(() => {
                    setIsLoading(false);
                });
            } else {
                apiGenericUpdate(ENTITY_ID_ORGANIZATIONS, organizationData, id).then(() => {
                    setIsLoading(false);
                    handleClose();
                    showToast(entityName + " is Updated!", TOAST_SUCCESS);
                    resetForm();
                    if (onSave) onSave();
                }).catch(() => {
                    setIsLoading(false);
                });
            }
        }
    });

    useEffect(() => {
        if (id != null) {
            setForUpdate(true);
            setTitle("Edit " + entityName);
            setIsLoading(true);
            genericGetOne(ENTITY_ID_ORGANIZATIONS, id).then(
                ({data}) => {
                    setObjectForSubmit(data);
                    setTitle("Update " + entityName);
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false);
                });
        } else {
            setForUpdate(false);
            setObjectForSubmit(defaultOrg);
            setTitle("New " + entityName);
        }
    }, [show]);


    return (
        <Modal
            size="lg"
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            aria-labelledby="example-modal-sizes-title-lg">
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="overlay">
                {!isLoading && (
                    <Form className="form form-label-right">
                        <div className="form-group row">

                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"Organization Name"}
                                         placeHolder={'Enter Organization Name'}
                                         id={"name"}
                                         toolTip={"Please enter the Organization Name"}
                                         value={formik.values.name}/>
                            </Form.Group>

                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"Phone Number"}
                                         placeHolder={'Enter Phone Number'}
                                         id={"phone"}
                                         toolTip={"Please enter the Organization POC Phone Number"}
                                         value={formik.values.phone}/>
                            </Form.Group>

                        </div>

                        <br/><br/>
                        <div className="form-group row">
                            <Form.Group className="col-lg-6">
                                <AGCTextArea formik={formik}
                                             name={"Address"}
                                             placeHolder={'Enter Address'}
                                             id={"address"}
                                             toolTip={"Please enter the Organization Address"}
                                             value={formik.values.address}/>
                            </Form.Group>

                            <Form.Group className="col-lg-6">
                                <AGCText formik={formik}
                                         name={"City"}
                                         placeHolder={'Enter City'}
                                         id={"city"}
                                         toolTip={"Please enter the Organization City"}
                                         value={formik.values.city}/>

                                <br/>
                                <AGCText formik={formik}
                                         name={""}
                                         placeHolder={'Enter Pin Code'}
                                         id={"pinCode"}
                                         toolTip={"Please enter the Organization Pin Code"}
                                         value={formik.values.pinCode}/>
                            </Form.Group>

                            <div className='separator my-6'/>

                            <div className="form-group row">
                                <Form.Group className="col-lg-6">
                                    <AGCText formik={formik}
                                             readOnly={forUpdate}
                                             name={"Admin User Name"}
                                             placeHolder={'Enter Admin Username'}
                                             id={"adminUserName"}
                                             toolTip={"Please enter the Organization Admin Username"}
                                             value={formik.values.adminUserName}/>
                                </Form.Group>

                                <Form.Group className="col-lg-6">
                                    <AGCPassword formik={formik}
                                                 readOnly={forUpdate}
                                                 name={"Admin Password"}
                                                 placeHolder={'Enter Admin User Password'}
                                                 id={"adminPassword"}
                                                 toolTip={"Please enter the Organization Admin Password"}
                                                 value={formik.values.adminPassword}/>
                                </Form.Group>
                            </div>

                            {!forUpdate && (
                                <div className="form-group row">
                                    <Form.Group className="col-lg-6">
                                        <AGCPassword formik={formik}
                                                     name={"Confirm Admin Password"}
                                                     placeHolder={'Re-enter Admin User Password'}
                                                     id={"adminPasswordConfirm"}
                                                     toolTip={"Please re-enter the Organization Admin Password to confirm"}
                                                     value={formik.values.adminPasswordConfirm}/>
                                        {formik.touched.adminPasswordConfirm && formik.errors.adminPasswordConfirm && (
                                            <div className="text-danger fs-8 mt-1">{formik.errors.adminPasswordConfirm}</div>
                                        )}
                                    </Form.Group>
                                </div>
                            )}
                        </div>

                        <Modal.Footer>
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-light btn-elevate"
                                    onClick={handleClose}>
                                    Cancel
                                </button>
                                <> </>
                                <button
                                    type="submit"
                                    onClick={formik.handleSubmit}
                                    className="btn btn-primary btn-elevate">
                                    Save
                                </button>
                            </div>
                        </Modal.Footer>
                    </Form>
                )}
                {isLoading && <span>Please Wait, Fetching Information from Server</span>}
            </Modal.Body>
        </Modal>
    );
}
